import IconTooltipButton from '../../../../../button/IconTooltipButton';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import GlobalReviewersPanel from '../../ReviewersPanel/GlobalReviewersPanel/GlobalReviewersPanel';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { updateFilter } from '../../../../../../store/actions/filter.actions';
import './GlobalReviewers.css';

const GlobalReviewers = ({}) => {
  const [showUsersDialog, setShowUsersDialog] = useState(false);
  const [isAddingReviewers, setIsAddingReviewers] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state?.dataEntryAssessmentBuilder?.assessmentsBuilder?.classesListLoading || false
  );
  const selectedTemplate = useSelector(
    (state) => state?.dataEntryAssessmentBuilder?.assessmentsBuilder?.template ?? null
  );
  const reviewersList = useSelector(
    (state) => state?.dataEntryAssessmentBuilder?.assessmentsBuilder?.reviewers || []
  );

  const handleReviewerModalClose = () => {
    setShowUsersDialog(false);
    setIsAddingReviewers(false);
    dispatch(updateFilter('assessmentReviewers', {}));
  };

  const handleReviewerModalConfirm = () => {
    setShowUsersDialog(false);
    setIsAddingReviewers(true);
  };

  return (
    <>
      <Box className='global-reviewers-button'>
        <IconTooltipButton
          title={'Assign Reviewers'}
          disabled={loading || !selectedTemplate}
          icon={'user-plus'}
          className={'assessment__reviewers-button shadow-sm'}
          onClick={() => {
            setShowUsersDialog(true);
          }}
        />
      </Box>
      <DialogConfirmCancel
        id={`assign-users-to-assessment-modal`}
        open={showUsersDialog}
        onCancel={handleReviewerModalClose}
        onConfirm={handleReviewerModalConfirm}
        loading={loading}
        title={'Assign assessment reviewers'}
        onCloseHeader={true}
        maxWidth='xl'
        scroll='body'
        className='assign-users-to-assessment-modal'
      >
        <GlobalReviewersPanel
          reviewersList={reviewersList || []}
          isConfirming={isAddingReviewers}
          setIsConfirming={setIsAddingReviewers}
        />
      </DialogConfirmCancel>
    </>
  );
};

export default GlobalReviewers;
